// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customDatePicker {\r\n    height: 25px;\r\n    margin-left: 10%;\r\n    text-align: center;\r\n    border-radius: 10px;\r\n    color: black;\r\n  }", ""]);
// Exports
module.exports = exports;
